import { render, staticRenderFns } from "./webinars.vue?vue&type=template&id=615d814a&"
import script from "./webinars.vue?vue&type=script&lang=js&"
export * from "./webinars.vue?vue&type=script&lang=js&"
import style0 from "./webinars.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "webinars.vue"
export default component.exports